import './styles.css';

import React, {Component, Fragment} from 'react';
import Constants from "../../constants/Constants";

class LandingPageHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            transform: "",
            width: window.innerWidth,
            hamBurger: 1,
            showHamBurgerContent: 0
        }

    }

    componentDidMount () {
        window.addEventListener('scroll', this.handleScroll);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount () {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth});
    };

    onClickHamburger = () => {
        this.setState({
            hamBurger: !this.state.hamBurger,
            showHamBurgerContent: !this.state.showHamBurgerContent
        });
    };

    onClickJobs = () => {
        const { history, location } = this.props;
        window.location.href = Constants.ROUTE.REACT_ROUTES.JOBS
        // history.push(Constants.ROUTE.REACT_ROUTES.JOBS);
        // location.reload();
    };

    onClickGetInTouch = () => {
        this.setState({
            hamBurger: !this.state.hamBurger,
            showHamBurgerContent: !this.state.showHamBurgerContent
        });
        this.props.onClickGetInTouch();
    };

    onClickLogin = () => {
        window.location.href = Constants.ROUTE.REACT_ROUTES.MOBILE_HOME_WITH_LOGIN
        // this.props.history.push(Constants.ROUTE.REACT_ROUTES.MOBILE_HOME_WITH_LOGIN);
    };

    onClickLogo = () => {
        window.location.href = "/";
        // this.props.history.push("/");
    };


    render() {

        const { showHamBurgerContent } = this.state;
        let customNavbarInformation = null, customStyleNiLogin = null;
        customNavbarInformation = {
            padding: '0 20px',
            height: '60px'
        };

        if(this.props.isAuthenticatedUser) {
            customNavbarInformation = {
                padding: '0 20px',
                height: '60px',
                background: '#0028ea'
            };
            customStyleNiLogin = {
                display: 'none'
            }
        }

        let classBar1 = "bar1";
        let classBar2 = "bar2";
        let classBar3 = "bar3";

        if(!this.state.hamBurger) {
            classBar1 = "bar1 change1";
            classBar2 = "bar2 change2";
            classBar3 = "bar3 change3";
        }

        return (
            <Fragment>
                <div
                    ref = { el => this.divRef = el }
                    onScroll = {this.handleScroll}
                    className = "navbar-information"
                    style = {customNavbarInformation}
                >

                    <div className="ni-navigation-list-left">
                        <div className="ni-logo" onClick={this.onClickLogo}>
                            <img src={Constants.ICONS.LOGO_WHITE_2} alt="TalentXO" />
                        </div>

                    </div>

                    {
                        this.state.width > 990 ?
                            <Fragment>
                                <div className="ni-navigation-list-middle">
                                    <div className="ni-jobs">
                                        <a href="/jobs">Jobs</a>
                                    </div>
                                    <div className="ni-get-in-touch">
                                        <a href="#get-in-touch">Get In Touch</a>
                                    </div>
                                </div>

                                <div className="ni-navigation-list-right">
                                    <div style={customStyleNiLogin} className="ni-login">
                                        <a href="/?login=1">Login</a>
                                    </div>
                                </div>

                            </Fragment>
                            :
                            <Fragment>
                                <div className="hamburger">
                                    <div className="hamburger-container" onClick={this.onClickHamburger}>
                                        <div className={classBar1}></div>
                                        <div className={classBar2}></div>
                                        <div className={classBar3}></div>
                                    </div>
                                </div>

                            </Fragment>

                    }

                </div>
                {
                    showHamBurgerContent && this.state.width < 990 ?
                        <div className="hamBurger-content">
                            <hr/>
                            <div className="hc-list">
                                <div className="hc-jobs" onClick={this.onClickJobs}>JOBS</div>
                                <div className="hc-get-in-touch" onClick={this.onClickGetInTouch}>GET IN TOUCH</div>
                                <div className="hc-login" onClick={this.onClickLogin}>LOGIN</div>
                            </div>
                        </div>
                        :
                        null
                }
            </Fragment>
        )
    }

}

export default LandingPageHeader;



// WEBPACK FOOTER //
// ./src/components/LandingPageHeader/LandingPageHeader.js